<template>
  <div :class="mainClass">
    <i
      v-for="i in 5"
      :key="i"
      :class="{ 
                  'fa': i <= reviewInfos.rating, 
                  'far': i > reviewInfos.rating, 
                  'fa-star': true 
                }"
    ></i>
    <span :class="ratingClass">
      <a href="#reviews">( {{ reviewInfos.reviews_number }} 件 )</a>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    reviewInfos: {
      type: Object,
      required: true
    },
    wrapperClass: {
      type: String,
      required: false,
      default: "product-item__rating"
    },
    ratingClass: {
      type: String,
      required: false,
      default: "product-item__rating__count"
    },
    extraClass: {
      type: String,
      required: false
    }
  },
  computed: {
    mainClass: function() {
      return `${this.wrapperClass} ${this.extraClass}`;
    }
  }
};
</script>